import { createContext, useContext } from 'react'

import { SubscriptionDto } from '@/shared/apis/fastmile/models/generated'

export type SubscriptionContextType = {
  subscription: SubscriptionDto | null
  isLoading: boolean
  isError: boolean
  isAuthenticated: boolean
  hasFeature: (feature: string) => boolean
  hasVehicleCapacity: (requiredVehicles: number) => boolean
  refetch: () => void

  isAtVehicleLimit: () => boolean
  canAccessRunsheet: () => boolean
  isFreeTier: () => boolean
}

export const SubscriptionContext = createContext<SubscriptionContextType | undefined>(undefined)

export const useSubscription = () => {
  const context = useContext(SubscriptionContext)

  if (!context) {
    throw new Error('useSubscription must be used within a SubscriptionProvider')
  }

  return context
}
